import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import RegisterSignature from "../task/RegisterSignature";

import { pqrsdText } from "./pqrsdLabel";
const DEFAULT_MIN_LEN = 10;

export default function ReturnPqrsdDialog({
  open,
  onClose,
  onConfirm,
  busy,
  // Some callers demand a fuller justification than a plain devolución — the
  // acto that decrees a desistimiento has to be motivado.
  minLength = DEFAULT_MIN_LEN,
  title = pqrsdText("Devolver PQRSD"),
  description = pqrsdText("Indica por qué no puedes atender esta PQRSD. El supervisor revisará el motivo y la reasignará a otro operario."),
  reasonLabel = "Motivo de devolución",
  confirmLabel = "Devolver",
  errorText = pqrsdText("No fue posible devolver la PQRSD."),
  // When the confirmed act is signed by the caller — the acto that decrees a
  // desistimiento is — their name lands in "Firmado electrónicamente por", so
  // they have to say so first. Same consent the flow tasks use.
  signatureAction = null,
}) {
  const [reason, setReason] = useState("");
  const [signed, setSigned] = useState(false);
  const [error, setError] = useState(null);

  const submit = async () => {
    const trimmed = reason.trim();
    if (trimmed.length < minLength) {
      setError(`Describe el motivo con al menos ${minLength} caracteres.`);
      return;
    }
    if (signatureAction && !signed) {
      setError("Registre su firma electrónica para continuar.");
      return;
    }
    try {
      setError(null);
      await onConfirm(trimmed);
      setReason("");
      setSigned(false);
    } catch (e) {
      setError(e?.message || errorText);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {description}
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField
          autoFocus
          multiline
          minRows={4}
          fullWidth
          label={reasonLabel}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          helperText={`${reason.length} / mínimo ${minLength} caracteres`}
        />
        {signatureAction && (
          <Box sx={{ mt: 2 }}>
            <RegisterSignature
              actionName={signatureAction}
              edit={!busy}
              signed={signed}
              setSigned={setSigned}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>Cancelar</Button>
        <Button
          onClick={submit}
          variant="contained"
          color="warning"
          disabled={busy || (!!signatureAction && !signed)}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
